import { useContext, useEffect } from 'react'
import AlertContext from './../context/alert/alertContext'
import { useSnackbar } from 'notistack'

const Alerts = () => {
    const { alerts, clearAlert } = useContext(AlertContext)
    const { enqueueSnackbar } = useSnackbar()

    useEffect(() => {
        alerts.forEach((alert) => {
            if (!alert?.msg) return
            enqueueSnackbar(alert.msg, {
                variant: alert.type || 'default',
                anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
            })
            clearAlert(alert.id)
        })
    }, [alerts])

    return null
}

export default Alerts
